import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { addToTrigger } from '../../features/quote/data/WatchTriggers';
import { actions, getCurrentStep, getQuote } from '../../features/quote/QuoteSlice';
import { Field, WatchTriggerInterface } from '../../types';
import { WatchTriggerActionType } from '../../types/enum';

interface CloneData {
  amount: number,
  trigger: string,
  fields: string[]
}

const useClonedFields = () => {
  const [clones, setClones] = useState<{index: number, clones: Field[]}>();
  const [cloneOffset, setCloneOffset] = useState<number>(0);
  const [loadedValues, setLoadedValues] = useState<{[key: string] : string}>({});
  const dispatch = useDispatch();
  const triggerProcessKey = '42';

  const quoteData = useSelector(getQuote);
  const currentStep = useSelector(getCurrentStep);

  useEffect(() => {
    if (window.quickInfoData && window.pageLoadDynamicQuestionAnswers !== null) {
      const values : {[key: string] : string} = {};
      Object.keys(window.pageLoadDynamicQuestionAnswers).forEach((loadedQuestionKey: any) => {
        const dynamicQuestions = window.pageLoadDynamicQuestionAnswers[loadedQuestionKey];
        dynamicQuestions.forEach((questionData: any) => {
          const clonedId = `${window.quickInfoData.formControlPrefix}${loadedQuestionKey}_${questionData.tag}`;
          if (window.quickInfoData
            && window.quickInfoData.industryCtrl.indexOf(loadedQuestionKey) > -1) {
            values[clonedId] = `${window.quickInfoData.formControlPrefix}${loadedQuestionKey}-${questionData.value}`;
          } else {
            values[clonedId] = `${window.quickInfoData.formControlPrefix}${loadedQuestionKey}_${questionData.tag}-${questionData.value}`;
          }
        });
      });
      setLoadedValues(values);
    }
  }, []);

  const createClones = (cloneData: CloneData) => {
    const insertClones: any = [];
    setCloneOffset(cloneData.fields.length);
    const insertIndex = quoteData.showData[cloneData.fields[
      cloneData.fields.length - 1]].fieldIndex;

    for (let i = 1; i < quoteData.numberOfFeeEarners; i += 1) {
      cloneData.fields.forEach((formId: string) => {
        if (quoteData.showData[formId]) {
          const cloned = JSON.parse(JSON.stringify(quoteData.showData[formId].field));
          cloned.parent = cloned.formId;
          cloned.label = `${cloned.label} ${i + 1}`;
          cloned.formId = `${cloned.formId}_${i + 1}`;
          cloned.value = quoteData.data[cloned.formId] || loadedValues[cloned.formId] || 'false';
          insertClones.push(cloned);

          dispatch(actions.updateOptionsForControl({
            formId: cloned.formId,
            options: quoteData.fieldOptions[cloned.formId] || quoteData.fieldOptions[cloned.parent],
          }));
          dispatch(actions.addToShowData({
            field: cloned,
            step: quoteData.step.step,
            fieldIndex: cloned.fieldIndex + 1,
            innerStep: quoteData.step.innerStep,
          }));
        }
      });
    }

    setClones({
      index: insertIndex,
      clones: insertClones,
    });
  };

  useEffect(() => {
    if (clones?.clones.length) {
      clones.clones.forEach((clone: Field) => {
        if (clone.formId.indexOf(triggerProcessKey) > -1) {
          addToTrigger(clone.formId, {
            values: ['all'],
            on: {
              type: WatchTriggerActionType.ProcessQuote,
              target: [],
            },
            off: {
              type: WatchTriggerActionType.None,
              target: [],
            },
            index: 0,
          });
        }
      });
    }
  }, [clones]);

  useEffect(() => {
    if (clones?.clones.length) {
      dispatch(actions.addToDisplayQueue([{
        step: [quoteData.step.step, quoteData.step.innerStep],
        index: clones.index + cloneOffset,
        trigger: quoteData.numberOfFeeEarnersCtr,
        fields: clones.clones,
      }]));
    }
  }, [clones]);

  return { clones, createClones };
};

export default useClonedFields;
